import React from 'react';
import AdminDashboard from '../../components/admin/AdminDashboard';

const Dashboard = () => {
  return <AdminDashboard />;
};

export default Dashboard;